import { getActiveElement } from '@/helpers';

export default () => {
  const activeElement = getActiveElement();

  return ['INPUT', 'TEXTAREA'].includes(activeElement?.tagName?.toUpperCase());
};
